import Card from '../Components/Card/Card';
import Footer from '../Components/Footer/Footer';
import HeroSection2 from '../Components/HeroSection2/Index';

const Produkt = () => {
  return (
    <>
      <HeroSection2 />
      <Card />
    </>
  )
}

export default Produkt